// import { createApp } from "vue";
// import App from "./App.vue";
// import router from "./router";
// // import store from "./store";
// import i18n from "./i18n";

// import "bootstrap";
// import "bootstrap/dist/css/bootstrap.min.css";
// import "@fortawesome/fontawesome-free/css/all.min.css";
// import "normalize.css";

// import VuePlyr from "vue-plyr";
// import "vue-plyr/dist/vue-plyr.css";

// // import "@/assets/images/images.css";

// createApp(App)
//   .use(VuePlyr, {
//     plyr: {},
//   })
//   .use(i18n)
//   // .use(store)
//   .use(router)
//   .mount("#app");
import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import i18n from "./i18n";

import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "@fortawesome/fontawesome-free/css/all.min.css";
import "normalize.css";

import VuePlyr from "vue-plyr";
import "vue-plyr/dist/vue-plyr.css";

// ⭐ استيراد اللودينج
import loadingPlugin from "@/plugins/loadingPlugin";
import GlobalLoading from "@/components/GlobalLoading.vue";

// 🚀 تحميل الإعدادات من backend/public/config.json
async function loadConfig() {
  try {
    const res = await fetch("/config.json");
    return await res.json();
  } catch (e) {
    console.error("❌ Failed to load config.json", e);
    return {}; // fallback
  }
}

loadConfig().then((config) => {
  const app = createApp(App);

  // ⭐ تسجيل GlobalLoading كـ component عالمي
  app.component("GlobalLoading", GlobalLoading);

  // ⭐ تفعيل plugin اللودينج
  app.use(loadingPlugin);

  // نجعل config متاح داخل كل الـ components
  app.config.globalProperties.$config = config;

  // ⭐ تحديث الـ title ديناميكياً
  document.title = config.siteName || "Website";

  // ⭐ تحديث اللون الأساسي
  document.documentElement.style.setProperty(
    "--primary-color",
    config.primaryColor || "#1abc9c"
  );
  document.documentElement.style.setProperty(
    "--secondary-color",
    config.secondaryColor || "#16a085"
  );
  document.documentElement.style.setProperty(
    "--third-color",
    config.thirdColor || "#2d9f75"
  );

  app.use(VuePlyr, { plyr: {} });
  app.use(i18n);
  app.use(store);
  app.use(router);

  // ⭐ تشغيل التطبيق
  app.mount("#app");
});
